// extracted by mini-css-extract-plugin
module.exports = {"root":"MergedInvoice_root__UlZKE","header":"MergedInvoice_header__Fvrq1"};